export default __webpack_public_path__ + "images/nVent-RAYCHEM-Logo-RGB-Horizontal.svg?913cef01f1782d65786cd38a468d6897";